import React from "react";
import { Box, Grid } from "@mui/material";
import { Navigation } from "components/Navigation";
import { Footer } from "components/Footer";
import { useLocation } from "react-router-dom";
import {
  MENU_NAMES,
  POWER_QUALITY_MENU,
  SPD_MENU,
  SOLUTION_MENU,
} from "const";

const PRODUCTS_PATH = `/${MENU_NAMES.PRODUCTS.key}`;
const POWER_QUALITY_PATH = `${PRODUCTS_PATH}/${POWER_QUALITY_MENU.POWER_QUALITY.key}`;

/**
 * 「제품」 영역은 어두운 배경을 쓰지만, 「기술 정보」에서 이관해 온 카테고리 대표
 * 페이지는 이관 전과 동일하게 밝은 배경을 유지한다. 해당 콘텐츠는 밝은 배경을
 * 전제로 작성되어 있어 어두운 배경에서는 읽히지 않는다.
 */
const LIGHT_BACKGROUND_PRODUCT_ROUTES = [
  `${PRODUCTS_PATH}/${SPD_MENU.SPD.key}`,
  `${PRODUCTS_PATH}/${SPD_MENU.SPD.key}/${SOLUTION_MENU.SURGE_INFO.key}`,
  `${POWER_QUALITY_PATH}/${POWER_QUALITY_MENU.HARMONIC_REDUCTION_SOLUTION.key}`,
  `${POWER_QUALITY_PATH}/${POWER_QUALITY_MENU.REACTIVE_POWER_IMPROVEMENT_SOLUTION.key}`,
];

export const Layout = ({ children, routes }) => {
  const location = useLocation();
  const currentPath = location.pathname.replace(/\/+$/, "") || "/";
  const isProductRoute =
    currentPath.startsWith(PRODUCTS_PATH) &&
    !LIGHT_BACKGROUND_PRODUCT_ROUTES.includes(currentPath);
  return (
    <Grid
      container
      direction="column"
      maxWidth="100%"
      sx={(theme) => ({
        minHeight: "100vh",
        backgroundColor: isProductRoute
          ? theme.palette.primary.black
          : "transparent",
      })}
    >
      <Grid item xs={12} style={{ position: "sticky", top: 0, zIndex: 2000 }}>
        <Navigation routes={routes} />
      </Grid>
      <Grid
        item
        xs={12}
        mt={location.pathname === "/" ? -8 : 0}
        // minWidth 를 0 으로 두지 않으면 flex 항목의 기본값(min-width:auto) 때문에
        // 본문 안의 넓은 표가 이 항목까지 밀어올려 문서 전체가 넓어진다.
        // 그 결과 모바일에서 본문과 햄버거 버튼이 잘린다.
        sx={{
          flexGrow: 1,
          minWidth: 0,
          maxWidth: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            minWidth: 0,
            maxWidth: "100%",
            backgroundColor: isProductRoute
              ? theme.palette.primary.black
              : "transparent",
          })}
        >
          {children}
        </Box>
      </Grid>
      <Grid item xs={12} sx={{ marginTop: "auto", display: "flex" }}>
        {/* if route is not home, show footer */}
        {location.pathname !== "/" && <Footer />}
      </Grid>
    </Grid>
  );
};
